var TYPES = {
    // heading: new RegExp(/^(\*([*]+)?\s[^\n]+)/, 'mgs')
    // heading: new RegExp(/^([*]+)\s([^\n]+)/, 'mg')
    heading: /^([*]+)\s([^\n]+)/mg
};

function removeAncestorsForLevel(ancestors, level) {
    var last = ancestors.pop();

    if (last && last.level > level) {
        return removeAncestorsForLevel(ancestors, level);
    }

    return ancestors[ancestors.length - 1];
}

var DATEIFY = /(?:DEADLINE|SCHEDULED):\s+(<|\[)(\d{4})-(\d{2})-(\d{2})([^>]+)?(>|\])/g;

function parseDate(content) {
    var splat = (content || '').split(DATEIFY)

    if (splat) {
        return new Date(splat[2], parseInt(splat[3]) - 1, splat[4]);
    }
}

function parse(content) {
    var headlines = [...content.matchAll(TYPES.heading)],
        nodes = [],
        ancestors = [],
        node, headline, nextHeadline, lastAncestor;

    if (content[0] !== '*') {
        nodes.push({
            type: 'paragraph',
            content: content.split(/([\n^]\*)/m)[0] + '\n',
            children: [],
            isExpanded: true
        });
    }

    for (var i = 0; i < headlines.length; i++) {
        headline = headlines[i];
        nextHeadline = headlines[i + 1];
        lastAncestor = ancestors[ancestors.length - 1];
        node = {
            type: 'headline',
            level: headline[1].length,
            value: headline[2],
            content: content.slice(
                headline.index + headline[1].length + headline[2].length + 2,
                nextHeadline ? nextHeadline.index : content.length - 1
            ),
            children: [],
            isExpanded: false
        };

        if (lastAncestor && lastAncestor.level >= node.level) {
            lastAncestor = removeAncestorsForLevel(ancestors, node.level);
        }

        node.date = parseDate(node.content);

        node.parent = lastAncestor;

        (lastAncestor ? lastAncestor.children : nodes).push(node);

        ancestors.push(node);
    }

    return nodes;
}

export default parse;
